import { InjectionToken } from '@angular/core';
import { IMapVisualizer } from './imap-visualizer';

export const MapVisualizer: InjectionToken<IMapVisualizer> = new InjectionToken('map-visualizer');



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/imagery/model/imap-visualizer.token.ts